module.exports = __webpack_public_path__ + "img/1 (123).c1a230c5.png";